export const slides = [
  {
    id: 1,
    className: 'slider1',
    content: {
      desc: 'Elevate Your Salon & Spa with Style',
      title: 'Luxury Equipment For Every Aesthetic',
      subDesc:
        'Discover our premium range of modern and classic salon and spa equipment, designed to match your brand\'s elegance. Shop now and transform your space.',
      link: '/shop',
    },
  },
  {
    id: 2,
    className: 'slider2',
    content: {
      desc: 'Create a Sophisticated and Inviting Salon',
      title: 'Functionality Meets Elegance',
      subDesc:
        'Upgrade your salon or spa with our curated range of equipment that combines comfort, style, and professional performance.',
      link: '/shop',
    },
  },
  {
    id: 3,
    className: 'slider3',
    content: {
              desc: 'Explore Our Finest Salon & Spa Equipment From Anywhere.',
              title: 'Stylish Equipment Elevates Your Space',
              subDesc:
                'Quality equipment transforms your salon or spa - shop our most popular and stylish pieces today.',
              link: '/shop',
            },
  },
];
